module.exports = __webpack_public_path__ + "static/media/delivery_icon.0dc2c9e1.svg";